enum USER_PANEL_TYPES {
    USER_ACTION = 'USER_ACTION',
    USER_LINK = 'USER_LINK',
}

export default USER_PANEL_TYPES;
